import React, { useState, useRef, useEffect } from 'react';
import { countries } from '../data/countries';
import '../styles/components/CountrySelect.css';

const CountrySelect = ({ value, onChange, placeholder }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCountry, setSelectedCountry] = useState(
    countries.find(country => country.code === 'FR') // Default to France
  );
  const dropdownRef = useRef(null);

  // Sync selectedCountry with value prop
  useEffect(() => {
    if (value) {
      const country = countries.find(c => c.dialCode === value);
      if (country) {
        setSelectedCountry(country);
      }
    }
  }, [value]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const filteredCountries = countries.filter(country =>
    country.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    country.dialCode.includes(searchTerm)
  );

  const handleSelect = (country) => {
    setSelectedCountry(country);
    onChange(country.dialCode);
    setIsOpen(false);
    setSearchTerm('');
  };

  return (
    <div className="country-select" ref={dropdownRef}>
      <div className="selected-country" onClick={() => setIsOpen(!isOpen)}>
        <span className="country-flag">{selectedCountry.flag}</span>
        <span className="country-dial-code">{selectedCountry.dialCode}</span>
        <span className="dropdown-arrow">▼</span>
      </div>
      
      {isOpen && (
        <div className="country-dropdown">
          <div className="search-container">
            <input
              type="text"
              placeholder="Rechercher un pays"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onClick={(e) => e.stopPropagation()}
              className="country-search"
            />
          </div>
          <div className="countries-list">
            {filteredCountries.map((country) => (
              <div
                key={country.code}
                className="country-option"
                onClick={() => handleSelect(country)}
              >
                <span className="country-flag">{country.flag}</span>
                <span className="country-name">{country.name}</span>
                <span className="country-dial-code">{country.dialCode}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default CountrySelect;
